import {DefaultResType, ErrorType} from "../../../types/common/response";
import {baseApi} from "../../../util/axiosConfig";
import {CompanySearchParamType} from "../../../pages/manage/company/interface";

const url = "api/admin/company/";

export async function readCompanyInfo(data: { id: number }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_company_info", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readCompanyMember(data: CompanySearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_company_member", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function downloadCompanyInfoReg(data: {
    fileKey: string;
    fileOrgname: string;
    fileUrl: string;
}): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.get("api/file/file_download", {
        params: data,
        responseType: "blob",
    });

    return response?.data;
}